import angular from 'angular';
import controller from './wfHisto.controller';
import template from './wfHisto.html';
import WfHistoComponent from './wfHisto.component';

const wfHistoConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('wfHisto', {
		title:                  'Workflow (history)',
		template,
		group:                  'advanced',
		children:               false,
		selectable:             true,
		settings:               new WfHistoComponent(),
		icon:                   'fa fa-clock-o',
		views:                  [
			{
				name:     'Display',
				template: 'kform/components/wfHisto/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/wfHisto/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		controller,
	});
};

export default angular.module('app').config(wfHistoConfig);
